import React, { useEffect } from 'react';
import { Layout, StatusTip, ConfigProvider } from 'tea-component';
import { useRequest } from 'ahooks';
import Chat from '@/pages/aigc/pages/Text2SQL/components/Chat';
import RelevantTable from '@/pages/aigc/pages/Text2SQL/components/RelevantTable';
import SqlResult from '@/pages/aigc/pages/Text2SQL/components/SqlResult';
import { useAigcIntl } from '@/pages/aigc/utils/utils';
import { getGameList } from '@/pages/aigc/pages/Text2SQL/service';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import './index.scss';

const { Content } = Layout;
export default () => {
  const { formatMessage: text2sqlFormat, isEn } = useAigcIntl('text2sql');
  const { data: gameList, loading, error } = useRequest(getGameList, { loadingDelay: 300 });

  useEffect(() => {
    buriedPointPage({
      pageId: '700301',
      pageName: 'Text2SQL',
      extInfo: '',
      pagePath: '/Text2SQL',
      typeId: 'aigc',
    });
  }, []);

  return (
    <ConfigProvider locale={isEn ? 'en' : 'zh'}>
      <Content>
        <Content.Header title={text2sqlFormat('title')} />
        <Content.Body full className={'text2sql-content-body'}>
          {loading ? (
            <StatusTip status={'loading'} />
          ) : error ? (
            <StatusTip status={'error'} />
          ) : gameList && gameList?.length > 0 ? (
            <>
              <Chat gameList={gameList} />
              <div className={'body-right'}>
                <RelevantTable />
                <SqlResult />
              </div>
            </>
          ) : (
            <StatusTip status={'empty'} />
          )}
        </Content.Body>
      </Content>
    </ConfigProvider>
  );
};
